export enum responseStatus {
  SUCCESS = 'success',
  ERROR = 'error'
}
